<template>
  <div class="animation-container">
    <!-- HOGC wrapper that scales based on orientation -->
    <div class="hogc-wrapper">
      <!-- 2x2 Grid for HOGC letters -->
      <div class="hogc-grid">
        <div class="grid-item">
          <img
            src="/assets/images/splash-screen/H.svg"
            :class="isAnimation ? fadeClass('H') : '!opacity-100'"
            class="fade character"
          />
        </div>
        <div class="grid-item">
          <img
            src="/assets/images/splash-screen/O.svg"
            :class="isAnimation ? fadeClass('O') : '!opacity-100'"
            class="fade character"
          />
        </div>
        <div class="grid-item">
          <img
            src="/assets/images/splash-screen/G.svg"
            :class="isAnimation ? fadeClass('G') : '!opacity-100'"
            class="fade character"
          />
        </div>
        <div class="grid-item">
          <img
            src="/assets/images/splash-screen/C.svg"
            :class="isAnimation ? fadeClass('C') : '!opacity-100'"
            class="fade character"
          />
        </div>
      </div>

      <!-- Logo always centered in the wrapper (overlay) -->
      <div class="logo-container" :class="[isAnimation ? 'signature-text' : 'opacity-100']">
        <img src="/assets/icons/hogc-logo.svg" class="w-full h-auto" />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'HOGCLogo',
  props: {
    isAnimation: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      fadeState: {
        H: false,
        O: false,
        G: false,
        C: false,
      },
    };
  },
  mounted() {
    if (this.isAnimation) {
      // Fade in the characters one by one
      setTimeout(() => (this.fadeState.H = true), 300);
      setTimeout(() => (this.fadeState.O = true), 600);
      setTimeout(() => (this.fadeState.G = true), 900);
      setTimeout(() => (this.fadeState.C = true), 1200);
    }
  },
  methods: {
    fadeClass(char) {
      return this.fadeState[char] ? 'fade-in' : '';
    },
  },
};
</script>

<style scoped>
.animation-container {
  display: flex;
  justify-content: center;
  align-items: flex-start;
  padding-top: 10vh;
  flex-shrink: 0;
}

/* Wrapper that maintains original sizes for portrait, scales for landscape */
.hogc-wrapper {
  position: relative;
  /* Scale based on available height and width with 20px side padding */
  height: min(50vh, calc(100vw - 40px));
  width: min(50vh, calc(100vw - 40px));
}

/* 2x2 Grid for HOGC letters */
.hogc-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-template-rows: 1fr 1fr;
  width: 100%;
  height: 100%;
  gap: clamp(4px, 1.5vmin, 12px);
}

.grid-item {
  display: flex;
  align-items: center;
  justify-content: center;
}

.character {
  width: 100%;
  height: 100%;
  object-fit: contain;
  opacity: 0;
  transition: opacity 0.1s ease;
}

/* Logo centered - scales with wrapper */
.logo-container {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 45%;
  text-align: center;
  z-index: 20;
  opacity: 1;
  pointer-events: none;
}

.logo-container.signature-text {
  animation: signatureAnimation 1s ease 0s 1 normal forwards;
}

.opacity-100 {
  opacity: 1;
}

.fade-in {
  opacity: 1 !important;
}

@keyframes signatureAnimation {
  0% {
    transform: translate(-50%, -50%) scale(1.5);
  }
  100% {
    transform: translate(-50%, -50%) scale(1);
  }
}

/* iPad adjustments - use full height and let vmin handle scaling */
@media (min-width: 768px) {
  .animation-container {
    height: 100vh;
  }
}

/* Landscape adjustments - different ratio for all landscape orientations */
@media (orientation: landscape) {
  .animation-container {
    padding-top: clamp(10px, 3vh, 30px);
  }

  .hogc-wrapper {
    height: clamp(120px, min(50vh, calc(100vw - 40px)), 500px);
    width: clamp(120px, min(50vh, calc(100vw - 40px)), 500px);
  }
}
</style>
